// extracted by mini-css-extract-plugin
module.exports = {"oneBoxStyle":"style_oneBoxStyle__QNiSl"};